import { text_colorTextSecondary } from 'ext-ui/style/colors'
import { css } from 'styled-components'

export default css`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  .fallback svg {
    color: ${text_colorTextSecondary};
  }
`
